import React, { useEffect, useMemo, useState } from "react";
import { Card, Empty } from "../../dashboard/primitives";
import MessagesThread from "../../dashboard/MessagesThread";
import { useAuth } from "../../auth/AuthContext";
import { subscribeAccountProjects } from "../../projects/api";
import { SkeletonList, SkeletonMediaRow } from "../../components/Skeleton";
import { useMinLoading } from "../../lib/useMinLoading";

const MessagesSection = () => {
  const { profile, canAct } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    if (!profile?.accountId) {
      setLoaded(true);
      return;
    }
    return subscribeAccountProjects(profile.accountId, (v) => {
      setProjects(v);
      setLoaded(true);
    });
  }, [profile?.accountId]);

  const showSkeleton = useMinLoading(!loaded);

  const active = useMemo(() => projects.find((p) => p.id === activeId), [projects, activeId]);

  useEffect(() => {
    if (!activeId && projects.length) setActiveId(projects[0].id);
  }, [projects, activeId]);

  if (showSkeleton) {
    return (
      <Card title="Messages">
        <SkeletonList count={4} ariaLabel="Loading messages">
          <SkeletonMediaRow />
        </SkeletonList>
      </Card>
    );
  }

  if (projects.length === 0) {
    return <Card title="Messages"><Empty>No active projects yet</Empty></Card>;
  }

  if (projects.length === 1) {
    return (
      <Card title={`Messages · ${projects[0].title}`}>
        <MessagesThread projectId={projects[0].id} readOnly={!canAct} />
      </Card>
    );
  }

  return (
    <Card title="Messages">
      <div className="fw-messages">
        <aside className="fw-messages__list">
          {projects.map((p) => (
            <button
              key={p.id}
              type="button"
              className={`fw-messages__item ${p.id === activeId ? "is-active" : ""}`}
              onClick={() => setActiveId(p.id)}
            >
              <div className="fw-messages__item-title">{p.title}</div>
              <div className="fw-messages__item-meta">
                <span>{p.type || "—"}</span>
              </div>
            </button>
          ))}
        </aside>
        <div className="fw-messages__pane">
          <MessagesThread projectId={active?.id} projectTitle={active?.title} readOnly={!canAct} />
        </div>
      </div>
    </Card>
  );
};

export default MessagesSection;
